import { render } from "./OrderCardList.vue?vue&type=template&id=dd944c3a&scoped=true"
import script from "./OrderCardList.vue?vue&type=script&lang=js"
export * from "./OrderCardList.vue?vue&type=script&lang=js"

import "./OrderCardList.vue?vue&type=style&index=0&id=dd944c3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd944c3a"]])

export default __exports__